/**
 * Puzzle pieces are cut from the admin's image. Cutting them at the image's FULL resolution made each
 * piece huge when there are few pieces (a 6000x4000 photo cut in 2 gives two 3000x4000 pieces), and the
 * reveal page, the canvas and every player's phone then download and decode all of them. Phones - iPhones
 * in particular - drop or refuse images when too much decoded image memory is in use, and the download
 * alone can take many seconds on mobile data.
 *
 * A piece is shown at a few hundred CSS pixels (a few thousand device pixels at the very most), so no
 * piece needs more than MAX_PIECE_SIDE pixels on its longest side. Smaller images keep their size.
 * The shape (width:height) is preserved exactly, which the board's alignment checks depend on.
 */
export const MAX_PIECE_SIDE = 1280;

export function fitPieceSize(width, height, maxSide = MAX_PIECE_SIDE) {
  const w = Math.max(1, Math.round(Number(width)) || 1);
  const h = Math.max(1, Math.round(Number(height)) || 1);
  const longest = Math.max(w, h);
  if (longest <= maxSide) return { width: w, height: h, scale: 1 };
  const scale = maxSide / longest;
  return {
    width: Math.max(1, Math.round(w * scale)),
    height: Math.max(1, Math.round(h * scale)),
    scale,
  };
}
